import React from 'react'
import {
    AiOutlinePlusCircle,
    AiOutlineDelete,
    AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import ToastNotification from '../../../components/ToastNotification';


const Recharge = () => {

    const [showForm, setShowForm] = useState(false);
    const [rechargeList, setRechargeList] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        contact_no: "",
        amount: "",
        status: "Pending"
    });


    // ====================handlers==================
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };

    const handleFormOpen = () => {
        setShowForm(true);
    }

    const filteredData = rechargeList.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    )

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleCancel = () => {
        setShowForm(false);
        setFormData({
            name: "",
            email: "",
            contact_no: "",
            amount: "",
            status: "Pending"
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const res = await axios.post('https://api.skyguard.group/api/add-recharge', formData);
            fetchRecharge();
            showToast('Recharge Added Successfully', 'success');

        } catch (error) {
            console.error(error);

            showToast('Recharge Adding Error', 'danger');
        }
        fetchRecharge();
        setShowForm(false);
        setFormData({
            name: "",
            email: "",
            contact_no: "",
            amount: "",
            status: "Pending"
        });
    }

    const formatDate = (datetime) => {
        const [date] = datetime.split(" ");
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
    };


    // =====================apis========================
    const fetchRecharge = async () => {
  try {
    const res = await axios.get('https://api.skyguard.group/api/fetch-recharge');

    setRechargeList(res.data);

    if (res.data.length > 0) {
      const latest = res.data[res.data.length - 1];
      setTotalAmount(Number(latest.totalAmount || 0));
    }

  } catch (error) {
    console.error(error);
  }
};


    useEffect(() => {
        fetchRecharge();
    }, [])


    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Recharge Now</h3>
                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Recharge
                            </button>


                        </div>

                    </div>
                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-end">

                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className="btn btn-primary">
                                Total Balance: ₹{totalAmount}
                            </button>
                        </div>


                    </div>

                    {/* Form Section */}
                    {showForm && (
                        <div className="card p-3 my-3 shadow-sm bg-white border">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    {/* left side */}
                                    <div className="col-md-6">
                                        <div className="row g-3">
                                            <div className='col-12'>
                                                <label className="form-label fw-medium">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className='col-12'>
                                                <label className="form-label fw-medium">Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* right side */}
                                    <div className="col-md-6">
                                        <div className="row g-3">
                                            <div className='col-12'>
                                                <label className="form-label fw-medium">Contact Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="contact_no"
                                                    value={formData.contact_no}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className='col-12'>
                                                <label className="form-label fw-medium">Amount</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="amount"
                                                    value={formData.amount}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className='d-flex justify-content-center mt-5 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        Recharge
                                    </button>

                                    <button
                                        type='button'
                                        className='btn btn-danger'
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>

                        </div>
                    )}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SN</th>
                                    <th>Name</th>
                                    <th>Contact Numbers</th>
                                    <th>Email</th>
                                    <th>Amount</th>
                                    <th>Created At</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((itm, index) => (
                                    <tr key={itm.id}>
                                        <td>{index + 1}</td>
                                        <td>{itm.name}</td>
                                        <td>{itm.contact_no}</td>
                                        <td>{itm.email}</td>
                                        <td>{itm.amount}</td>
                                        <td>{formatDate(itm.created_at)}</td>
                                        <td>
                                            {itm.status === 'Approved' ? (
                                                <span className='badge bg-success'>{itm.status}</span>
                                            ) : itm.status === 'Rejected' ? (
                                                <span className='badge bg-danger'>{itm.status}</span>
                                            ) : (
                                                <span className='badge bg-warning text-dark'>{itm.status}</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
        </>
    )
}

export default Recharge